<script lang="ts">
	import { InputCheckboxes } from '@wiseed/wikit';
	import { beforeUpdate } from 'svelte';
	import type { AppInputCheckboxProps } from '@app/types/Inputs';

	export let props: AppInputCheckboxProps;

	$: props.handleChangeCallbackFunction = (e) => {
		if (props.renderSpecificValue) {
			let { value, checked } = e.target as HTMLInputElement;
			let dataId = (e.target as HTMLElement).getAttribute('data-id');
			if (!props.specificValue) {
				props.specificValue = [];
			}
			if (checked) {
				if (dataId) props?.specificValue.push({ id: parseInt(dataId), value: value });
			} else {
				const itemIndexToRemove = props?.specificValue.findIndex((item) => {
					if (dataId) return item.id === parseInt(dataId);
				});
				if (itemIndexToRemove !== -1) {
					props.specificValue.splice(itemIndexToRemove, 1);
				}
			}
		}
	};

	beforeUpdate(() => {
		if (props.renderSpecificValue && typeof props?.value[0] !== 'string') {
			if (props.specificValue && Array.isArray(props.specificValue)) {
				props.value = [];
				props?.specificValue?.forEach((item) => {
					props.value.push(item.value);
				});
			}
		}
	});
</script>

<InputCheckboxes bind:props />
